import React, { useState, useEffect } from 'react';
import dataManager from '../utils/dataManager';

const DataTest = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadAllData = async () => {
      try {
        setLoading(true);
        setError(null);

        // 并行加载所有异步数据
        const [
          poses,
          teachers,
          philosophy,
          communityStories,
          feelingInsights,
          practiceReflections,
          allPoses
        ] = await Promise.all([
          dataManager.getPoses(),
          dataManager.getTeachers(),
          dataManager.getPracticePhilosophy(),
          dataManager.getCommunityStories(),
          dataManager.getFeelingInsights(),
          dataManager.getPracticeReflections(),
          dataManager.getAllPoseNames()
        ]);

        // 同步数据
        const storyCategories = dataManager.getStoryCategories();
        const insightTypes = dataManager.getInsightTypes();
        const feelingOptions = dataManager.getFeelingOptions();

        setData({
          poses,
          teachers,
          philosophy,
          storyCategories,
          insightTypes,
          feelingOptions,
          communityStories,
          feelingInsights,
          practiceReflections,
          allPoses
        });
      } catch (err) {
        console.error('Error loading test data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadAllData();
  }, []);

  if (loading) {
    return <div style={{ padding: '2rem' }}>加载测试数据中...</div>;
  }

  if (error) {
    return <div style={{ padding: '2rem', color: 'red' }}>加载失败: {error}</div>;
  }

  const {
    poses,
    teachers,
    philosophy,
    storyCategories,
    insightTypes,
    feelingOptions,
    communityStories,
    feelingInsights,
    practiceReflections,
    allPoses
  } = data;

  return (
    <div style={{ padding: '2rem', fontFamily: 'monospace', fontSize: '12px' }}>
      <h2>数据加载测试</h2>
      
      <div style={{ marginBottom: '2rem' }}>
        <h3>体式数据 (Poses)</h3>
        <p>总分类数: {Object.keys(poses).length}</p>
        <p>总体式数: {allPoses.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(poses, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>老师数据 (Teachers)</h3>
        <p>老师数量: {teachers.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(teachers, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>练习哲学 (Philosophy)</h3>
        <p>哲学项目数: {philosophy.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(philosophy, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>故事分类 (Story Categories)</h3>
        <p>分类数量: {storyCategories.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(storyCategories, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>洞察类型 (Insight Types)</h3>
        <p>类型数量: {insightTypes.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(insightTypes, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>感受选项 (Feeling Options)</h3>
        <p>选项数量: {feelingOptions.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(feelingOptions, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>社区故事 (Community Stories)</h3>
        <p>故事数量: {communityStories.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(communityStories, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>感悟洞察 (Feeling Insights)</h3>
        <p>洞察数量: {feelingInsights.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(feelingInsights, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>体式反思 (Practice Reflections)</h3>
        <p>体式反思数量: {practiceReflections.length}</p>
        <details>
          <summary>查看详情</summary>
          <pre>{JSON.stringify(practiceReflections, null, 2)}</pre>
        </details>
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>所有体式名称 (All Pose Names)</h3>
        <p>体式名称列表: {allPoses.join(', ')}</p>
      </div>
    </div>
  );
};

export default DataTest;
